import { render, staticRenderFns } from "./myFooter.vue?vue&type=template&id=6ed46b0d&scoped=true&"
import script from "./myFooter.vue?vue&type=script&lang=js&"
export * from "./myFooter.vue?vue&type=script&lang=js&"
import style0 from "./myFooter.vue?vue&type=style&index=0&id=6ed46b0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed46b0d",
  null
  
)

export default component.exports